import React from 'react';

import {ACCOUNT_STRIP_LABELS} from 'src/components/criteria-strip/constants';
import {useAccountEntityTypes} from 'src/hooks/dictionaries';

import {ComboBox, ComboboxItem, DefaultItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';


type Props = {
    onSelect: (entityType: string) => void,
    selectedEntityType?: string,
};

export const EntityType = ({onSelect, selectedEntityType}: Props) => {
    const {accountEntityTypes} = useAccountEntityTypes();

    return (
        <div>
            <Group justify="space-between">
                <Label>{ACCOUNT_STRIP_LABELS.entityType}</Label>
            </Group>
            <ComboBox
                placeholder="Select entity type"
                value={selectedEntityType}
                onChange={onSelect}>
                {
                    [
                        <DefaultItem key="None" value=""/>,
                        ...accountEntityTypes.map(({code, description}) => (
                            <ComboboxItem key={code} caption={description} value={code}/>
                        )),
                    ]
                }
            </ComboBox>
        </div>
    );
};
